import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertController, PopoverController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { TutorialPopoverComponent } from 'src/app/pages/components/tutorial-popover/tutorial-popover.component';


@Injectable({
	providedIn: 'root'
})
export class AlertService {

	alert;

	constructor(
		private alertController: AlertController,
		private toastController: ToastController,
		private _snackBar: MatSnackBar,
		private translateService: TranslateService,
		public popoverController: PopoverController) { }

	percentProgress = new BehaviorSubject(0);  // usando para mostrar el porcentaje en subida de imagenes al servidor

	async basicAlert(message, buttons, header?, subHeader?,) {
		this.alert = await this.alertController.create({
			header,
			subHeader,
			message,
			buttons
		});

		this.alert.present();
	}

	async presentToast(message, duration, showCloseButton = false) {
		const options = showCloseButton ? {
			message,
			buttons: ['Close'],
			cssClass: 'toast-button-custom',
		} : {
			message,
			duration,
		}
		const toast = await this.toastController.create(options);
		toast.present();
	}

	async presentPopover(ev: Event, id_tutorial: number) {
		const popover = await this.popoverController.create({
			component: TutorialPopoverComponent,
			cssClass: 'custom-popover-tutorial',
			keyboardClose: true,
			event: ev,
			translucent: false,
			componentProps: {
				id_tutorial: id_tutorial
			}
		});

		return await popover.present();

	}

	async openSnackBar(message: string, time) {
		this._snackBar.open(message, this.translateService.instant('ACEPTAR'), {
			duration: time,
		});
	}

	updateProgressPercent(progress) {
		this.percentProgress.next(progress);
	}

}
